import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageNavigation } from '../utils/apiUtils';

// Custom hook to track page visits
export const usePageTracking = (pageName) => {
  const location = useLocation();

  useEffect(() => {
    if (pageName) {
      // Track the page when component mounts or pageName changes
      trackPageNavigation(pageName);
    }
  }, [pageName, location.pathname]);

  // Return a function to manually track page navigation if needed
  const trackPage = (customPageName) => {
    trackPageNavigation(customPageName || pageName);
  };

  return { trackPage };
};

export default usePageTracking;
